<script>
 /**
  * @vue-prop {String} route - The route to use for API calls
  * @vue-prop {String} event - The event name
  * @vue-prop {String} model - The model name
  * @vue-prop {String} path - The router path
  * @vue-prop {String} title - The title of the listing
  * @vue-prop {String} title - The vue component that we will use to display the items.
  * @vue-prop {String} modalid - The ID used for the internal modal used for filters.
  * @vue-prop {Boolean} subroute=1 - Whether the router is a subroute
  * @vue-data {Object|Array} items - The items to list
  * @vue-data {Object|Array} filterFields - The filter fields available
  * @vue-data {Number} page - The current page
  * @vue-data {Object|Array} errors - An array of errors to display
  * @vue-data {Object|Array} quickFilters - The quick filters available
  * @vue-computed {Boolean} stale Whether we have been disconnected from the server websockets.
  */
	export default {
		props: {
			
		},
		data: function(){
			return {
                route: null,
                event: null,
                model: null,
                // @todo Review this as we can just use this.$router.path
                path: null,
                title: null,
                modalid: null,
                subroute: 1,
				items: {
                    data: []
                },
				filterFields: {},
				page: 1,
				errors: [],
				notification: "",
				test_state: true,
				per_page: 10,
				quickFilters: {
					//assigned: false
				},
                sort: {field: "created_at", dir: "desc"},
                resultsRequestTimer: null,
                site_id: "",
                source_id: "",
                source_provider_id: "",
                resultRequests: [],
                stale: false,
                archive: false,
                // Should be enabled for
                    // "usergroup"
                    // "feedback"
                force_na_provider_id: false,
                // Should be disabled for staff and patient
                search_on_open: true,
			};
		},
		computed: {
            provider_id: {
                get: function() {
                    if(this.is_network_admin()) {
                        return this.$root.admin_provider_id;    
                    }
                    else {
                        return this.$root.provider.id;
                    }
                }
            },
		},
		watch: {
            provider_id(new_provider_id, old_provider_id) {
                this.$router.push({path: "/" + this.event + "-list"});
                this.getResults(1)
            },
            
    		"$root.connected" (newState, oldState) {
                if(newState == true && oldState == false) {
                    if(this.appActive()) {
                        this.getResults();
                    }
                    else {
                        this.stale = true;
                    }
                }
            },
            "$root.visibility" (newState, oldState) {
                if(newState == "visible" && this.stale) {
                    this.getResults();
                }
		    },
			per_page(value) {
				this.setSetting("per_page", value);
			},
			sort(value) {
				this.setSetting("sort", value);
            },
            site_id(value) {
				this.setSetting(this.event + "_site_id", value);
            },
            source_provider_id(value) {
				this.setSetting(this.event + "_source_provider_id", value);
            },
            source_id(value) {
                this.changeSource();
            },
            quickFilters: {
                handler(val) {
                    this.setSetting(this.event + "_quick_filter", this.quickFilters);
                },
                deep: true
            }

		},
		created() {
        },
		beforeDestroy() {
			this.deinitData();
		},
		beforeRouteLeave (to, from, next) {
			this.deinitData();
    		next();
		},
        mounted() {
            this.initSettings();
            
			this.initData();
		},
		methods: {
            initSettings() {
                this._initSettings();
            },
            _initSettings() {
                this.per_page = this.getSetting("per_page");
                this.sort = this.getSetting("sort");

                // Check that the site_id is valid
                var thisSiteId = this.getSetting(this.event + "_site_id", "");
                if(this.$root.provider.site.find(obj => {return obj.id == thisSiteId})) {
                    this.site_id = thisSiteId;
                    this.source_provider_id = "";
                    this.source_id = `site_${this.site_id}`;
                }
                else {
                    this.setSetting(this.event + "_site_id", "");
                }

                // Check that the source_id is valid
                var thisSourceProviderId = this.getSetting(this.event + "_source_provider_id", "");
                if(this.$root.provider.provider_provider_xref.find(obj => {return obj.relation_id == thisSourceProviderId})) {
                    this.source_provider_id = thisSourceProviderId;
                    this.site_id = "";
                    this.source_id = `provider_${this.source_provider_id}`;
                }
                else {
                    this.setSetting(this.event + "_source_provider_id", "");
                }
                
                this.quickFilters = this.getSetting(this.event + "_quick_filter", {});
                if(this.quickFilters["advanced"] && this.quickFilters["advanced"] == true) {
                    this.resetQuickFilters();
                }
            },
			deinitData() {
				if(this.resultsRequestTimer) {
                    console.log("Clearing timer.")
                    clearTimeout(this.resultsRequestTimer);
                }
			},
			/**
			 * Toggle quick filters
			 * @param  {String} filter The filter to toggle
			 */
			toggleFilter(filter) {
                if(this.$route.path != "/" + this.event + "-list") {
                    this.$router.push({path: "/" + this.event + "-list"});
                }
				for(var index in this.quickFilters) {
					if(index == filter) {
						//this.quickFilters[index] = !this.quickFilters[index];
						this.quickFilters[index] = true;
					}
					else {
						this.quickFilters[index] = false;
					}
                }
                // Reset the archive flag when we change filters.
                this.archive = false;
				if(filter !== "advanced") {
					this.$refs.listFilter.clearFilters(null);
					this.$refs.listFilter.appliedFilters = [];
					this.getResults(1);
				}
            },
            updateItem(newItem, ignore = []) {
                var found = false;

                if(this.items && Array.isArray(this.items.data)) {
					console.log("Processing min update.");
					for(var index in this.items.data) {
						if(this.items.data[index].id == newItem.thread.id) {
							found = true;
							//Vue.set(this.items.data, index, newItem.thread);
							for (var attrname in newItem.thread) {
								if(!ignore.find(value => {return attrname == value})) {
									console.log("Setting: " + attrname + ")" + this.items.data[index][attrname] + " to " + newItem.thread[attrname]);
									this.items.data[index][attrname] = newItem.thread[attrname];
								}
								else {
									console.log("Ignoring: " + attrname);
								}
							}
						}
					}
                }
                console.log("updateItem: " + found);
                return found;
            },
			addOrUpdateItem(newItem, ignore = []) {
                // Note that we currently fall back to calling getResults
                // This is because the user may be in a filtered listing that
                // shouldn't display the new item. The logic for the filters is
                // quite complex, and we don't want to duplicate it client side.
				if(!this.updateItem(newItem, ignore)) {
                    this.requestGetResults();
                    //this.getResults(undefined, false);
				}
				//
				// if(!found && this.items.current_page == 1) {
				// 	if(this.items && Array.isArray(this.items.data)) {
				// 		this.items.data.unshift(newItem.thread);
				// 		if(this.items.data.length > this.items.per_page) {
				// 			this.items.data.pop();
				// 		}
				// 	}
				// 	else {
				// 		this.getResults(undefined, false);
				// 	}
				// }
            },
            haveIncomingFilterParameters() {
                return false;
            },
            resetQuickFilters() {
                this.$set(this.quickFilters, 'assigned', false);
                if(this.$root.provider.demo_mode) {
                    this.$set(this.quickFilters, 'unassigned', false);
                    this.$set(this.quickFilters, 'mine', true);
                }
                else {
                    this.$set(this.quickFilters, 'unassigned', true);
                    this.$set(this.quickFilters, 'mine', false);
                }

                // this.$set(this.quickFilters, 'waiting', false);
                this.$set(this.quickFilters, 'closed', false);
                this.$set(this.quickFilters, 'waiting', false);
                this.$set(this.quickFilters, 'advanced', false);
            },
			initData() {
				this.setLoading(true);
				this.items = {};
				this.errors = [];

				
				this.quickFilters = {};
                if(this.$root.lookup.relatedData[this.route]) {
                    this.processRelatedData(this.$root.lookup.relatedData[this.route]);
                }
                else {
                    axios.get(this.route + '/relatedData').then((res) => {
                        this.$root.lookup.relatedData[this.route] = res.data;
                        this.processRelatedData(res.data);
                    }).catch(error => {
                        this.setLoading(false);
                        this.handleError(error, "load");
                    });
                }
            },
            processRelatedData(data) {
                for(var key in data) {
                    this[key] = data[key];
                }
                this.initFilters();

                if(this.search_on_open) {
                    if(!this.haveIncomingFilterParameters()) {
                        this.getResults(1);
                    }
                }
                else {
                    this.setLoading(false);
                }
            },
			setFiltersFromRouteParams() {
            },
			initFilters() {
                if(this.$refs.listFilter) {
                    if(this.$root.lookup.filters[this.route]) {
                        Vue.nextTick(() => {
                            this.$refs.listFilter.filterFields = this.$root.lookup.filters[this.route];
                            this.$refs.listFilter.clearFilters(null);
                            this.setFiltersFromRouteParams();
                        });
                    }
                    else {
                        this.setLoading(true);
                        axios.get(this.route + '/getFilters').then((res) => {
                            this.$root.lookup.filters[this.route] = res.data;
                            this.$refs.listFilter.filterFields = res.data;
                            this.$refs.listFilter.clearFilters(null);
                            this.setFiltersFromRouteParams();
                        });
                    }
                }
			},
			changePerPage() {
				// Funny race condition in firefox so we have to do this nextTick.
				Vue.nextTick(() => {this.getResults(1)});
			},
			setSort() {
				this.getResults();
            },
            forceGetResults() {
                console.log('Forcing immediate update.')
                if(this.resultsRequestTimer) {
                    clearTimeout(this.resultsRequestTimer);
                    this.resultsRequestTimer = null;
                }
                var backoff = 2000 + (Math.random() * 3000);
                this.requestGetResults(backoff);
            },
            updateResultRequests() {
                var resultIndex = this.resultRequests.length;
                while (resultIndex--) {
                    if (this.moment().diff(this.resultRequests[resultIndex], "minutes") >= 5) {
                        this.resultRequests.splice(resultIndex, 1);
                    }
                }
                this.resultRequests.push(this.moment());
            },
            requestGetResults(backoff) {
                this.updateResultRequests();
                // this.getResults(undefined, false);
                // return;
                if(this.resultsRequestTimer) {
                    // Toyed with the idea of continual back-off, but we would need some way to say enough is enough.
                    //clearTimeout(this.resultsRequestTimer);
                    //this.addNotification({type: "warning", content: 'Waiting for request update.'});
                    console.log('Waiting for request update.')
                    return;
                }

                if (typeof backoff === 'undefined') {
					backoff = (Math.min(this.resultRequests.length, 100) * 1000) + (Math.random() * 15000);
				}

                console.log('Backing off for ' + (backoff / 1000) + ' seconds.');
                this.resultsRequestTimer = setTimeout(() => {
                    // Clear has to happen outside of the get as the query may have already occurred if
                    // we wait for the promise to return
                    this.resultsRequestTimer = null;
                    this.getResults(undefined, false).then(() => {
                        // See note above.
                        //this.resultsRequestTimer = null;
                    });
                    //this.addNotification({type: "success", content: 'Request timeout update after ' + (backoff / 1000) + 'seconds.'});
                    console.log('Request timeout update after ' + (backoff / 1000) + ' seconds.')
                }, backoff);
            },
			// @updatehere
			getResults(page, showLoading, prevent) {
                //console.log(this.route);
                if(!this.appActive()) {
                    this.stale = true;
                    return Promise.reject("Application is not active. Data set to 'stale'. Will update when active.");
                }
                if (typeof showLoading === 'undefined') {
					showLoading = true;
				}

				if(showLoading) {
					this.setLoading(true);
				}

				if (typeof page !== 'undefined') {
					this.items.current_page = page;
				}

				var search = (this.$refs && this.$refs.listFilter ? this.$refs.listFilter.$refs.search.value : "");

				var filter = encodeURIComponent(JSON.stringify(this.quickFilters));

				if(this.$refs && this.$refs.listFilter && this.$refs.listFilter.filterShown && this.$refs.listFilter.appliedFilters) {
					search = encodeURIComponent(JSON.stringify(this.$refs.listFilter.appliedFilters));
				}

                var params = {sort: this.sort};

                // Made this specific to user groups for now, but it can be used for
                // other event types if we move stuff around in the network admin interface.
                if(this.is_network_admin() && this.force_na_provider_id) {
                    params.provider_id = this.provider_id;
                }

				return axios.get(this.route + '?site_id=' + (this.site_id ? this.site_id : "") + '&search=' + search + '&filter=' + filter + '&page=' + this.items.current_page + '&p=' + this.per_page, {params: params}).then((res) => {
					//console.log("current_page: " + res.data.current_page);
					//console.log("last_page: " + res.data.last_page);
					if(res.data.current_page > res.data.last_page && prevent !== true) {
						console.log("Re-searching with page in range.");
						this.items = {};
						this.getResults(res.data.last_page, showLoading, true)
					}
					else {
						this.setLoading(false);
						this.items = res.data;
					}
				}).catch((error) => {
					if(showLoading) {
						this.setLoading(false);
					}
					this.handleError(error, "load");
					//this.$router.push({path: "/" + this.event + "-list"});
				});

			},
			getOpenLink(event, id) {
				if(this.subroute) {
					return {path: "/" + this.event + "-list" + "/" + this.event + '-show/' + id};
				}
				else {
					return {path: "/" + this.event + '-show/' + id};
				}
            },
            // Deprecated. Use getOpenLink and a proper router-link instead.
            openView(event, id) {
				if(this.subroute) {
					this.$router.push({path: "/" + this.event + "-list" + "/" + this.event + '-show/' + id});
				}
				else {
					this.$router.push({path: "/" + this.event + '-show/' + id});
				}
			},
			openCreate(event) {
				this.$router.push({path: "/" + this.event + "-list" + "/" + this.event + '-create'});
			},
			debug() {
				console.log(this.items.data)
			},
			showFilter() {
				$(this.$refs.listFilter.$refs.modal).modal("show");
				setTimeout(function() {
					if (this.$refs.listFilter.filterShown) {
    					$(this.$refs.listFilter.$refs["filter-value-0"]).focus();
    				}
    				else {
    					$(this.$refs.listFilter.$refs.search).focus();
    				}
		        }.bind(this), 500);

			},
			viewNext(id) {
				var foundNext = false;
				this.items.data.forEach((value, index, array) => {
					if(this.items.data[index].id == id) {
						if(this.items.data.length > index + 1) {
							this.$router.push({path: "/" + this.event + "-list/" + this.event + "-show/" + this.items.data[index + 1].id});
							foundNext = true;
						}
					}
				});
				if(!foundNext) {
					this.$router.push({path: "/" + this.event + "-list"});
					return false;
				}

            },
            changeSite() {
                Vue.nextTick(() => {this.getResults(1)});
            },
            changeSource() {
                var parts = this.source_id.split("_");
                switch(parts[0]) {
                    case "site":
                        this.site_id = parts[1];
                        this.source_provider_id = "";
                        break;
                    case "provider":
                        this.source_provider_id = parts[1];
                        this.site_id = "";
                        break;
                    default:
                        this.site_id = "";
                        this.source_provider_id = "";
                }
                Vue.nextTick(() => {this.getResults(1)});
            },
            enableArchive() {
                //this.$root.checkArchive();
                
                this.archive = true;
                this.getResults();
            }
		}
    }
</script>
